var map = {
	"./Announcement.scss": "w2MC",
	"./AnnouncementCard": "UXfg",
	"./AnnouncementCard.js": "UXfg",
	"./AnnouncementCard.scss": "cNYk",
	"./DefaultTab": "rhuv",
	"./DefaultTab.js": "rhuv",
	"./constant": "ENiu",
	"./constant.js": "ENiu",
	"./images/Announcement.png": "JsbR",
	"./images/Announcement_en@2x.png": "z9ID",
	"./index": "9ZkX",
	"./index.js": "9ZkX",
	"./locale": "m3Lh",
	"./locale.js": "m3Lh",
	"./redux/actions/addAnnouncement": "/Cga",
	"./redux/actions/addAnnouncement.js": "/Cga",
	"./redux/actions/deleteAnnouncement": "y2+x",
	"./redux/actions/deleteAnnouncement.js": "y2+x",
	"./redux/actions/getAnnouncementList": "sYDS",
	"./redux/actions/getAnnouncementList.js": "sYDS",
	"./redux/actions/searchAnnouncement": "EV0/",
	"./redux/actions/searchAnnouncement.js": "EV0/",
	"./redux/actions/setCurrentTabState": "d4iu",
	"./redux/actions/setCurrentTabState.js": "d4iu",
	"./redux/actions/updateAnnouncement": "eVF0",
	"./redux/actions/updateAnnouncement.js": "eVF0",
	"./redux/reducer": "pzkK",
	"./redux/reducer.js": "pzkK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;



//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Announcement ^\.\/.*$
// module id = 6
// module chunks = 0